import styled from 'styled-components';

import MuiAlert from '@material-ui/lab/Alert';
import Link from '@material-ui/core/Link';

export const FixedWrapper = styled.div`
  max-width: 500px;
  height: auto;
  margin: auto;
  position: fixed;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    width: calc(100% - 1rem);
    margin: 0 0.5rem;
  }
`;

export const AuthOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  width: inherit;
  height: inherit;
  background-color: #f5f6fa;
`;

export const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  width: 500px;
  height: auto;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const ErrorWrapper = styled(MuiAlert)`
  display: ${({ show }) => (show ? 'flex' : 'none')} !important;
  margin: 2rem 1rem 0 1rem;
`;

export const AdditionalMargin = styled.div`
  margin: 1rem;
`;

export const AuthHeader = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin-top: 1rem;
`;

export const HeaderImg = styled.img`
  width: 5rem;
  height: 5rem;
`;

export const HeaderText = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 0.5rem;
  color: #4d74ba;
`;

export const FooterWrapper = styled.div`
  display: flex;
  margin: 0 1rem 1rem 1rem;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
  -webkit-justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
`;

export const FooterText = styled.span`
  color: #95afc0;
  cursor: pointer;

  :hover {
    color: #535c68;
  }
`;

export const FooterLinkWrapper = styled.div`
  display: inline-flex;
  padding: 0 2rem;
`;

export const FooterLink = styled(Link)`
  color: #95afc0;

  :hover {
    color: #535c68;
  }
`;
